// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-container{
    display: flex;
    flex-direction: column;
    
}

.list-container .single-list{
    margin: 10px 10px;
    display: flex;
    justify-content: space-between;
}
.list-container li{
    display: inline-block;
    width: 40%;
}

.list-container .cross-icon:hover{
    cursor: pointer;
}

.rendered-heading{
    margin: 5px 10px;
    font-size:medium;
    text-transform: uppercase;
}

.compaign-form{
    border: 1px solid #343A40 ;
    border-radius: 5px;
    padding: 10px 10px;
    position: relative;
}

.compaign-form .submit{
    position: absolute;
    bottom: 5px;
    right: 4px;
    padding:3px 3px;
    border: 1px solid black;
    border-radius: 10%;
}

.compaign-form .submit:hover{
    cursor: pointer;
    background-color: #c6d4e1;
}

.compaign-form .options-container{
    display: flex;
    justify-content: space-between;
    width: 85%%;
}

.options-container .channel{
    display: flex;
    flex-direction: column;
}

.options-container .channel span{
    color: red;
}

.options-container select,input{
    height: 25px;
    padding: 2px 5px;
    outline: none;
}

.optional-options{
    margin-top: 15px;
    margin-bottom: 45px;
}

.optional-options-container{
    display: flex;
    width: 95%;
    margin: 5px 0px;
    justify-content: space-between;
}



.optimization, .added-value{
    display: flex;
    justify-content: center;
    text-align: center;
}

.optimization label, .added-value label{
    margin-right: -10px;
}

axiOptimization{
    margin-left: -5px;
}


.download-button:hover{
    cursor: pointer;
    background-color: #DEE2E6;
}

.optional-options-container input[type='text']{
    width: 250px;
}

.input-label{
    margin-right: -5px;
}


.campaign-number span{
    color: red;
    margin-right: 5px;
}

.platform-container span{
    color: red;
}

.adgroup-form .buttons {
    position: absolute;
    bottom: 5px;
    right: -5px;
}

.buttons{
    position: absolute;
    margin-right: 10px;
    display: flex;
    width: 150px;
    justify-content: space-around;
    left: 86%;
    bottom: 5px;
}

.buttons button{
    padding: 2px 5px;
}

.pl-container{
    display: flex;
    flex-direction: column;
}

.pl-container span{
    font-size: 12px;
}

.asterick{
    display: flex;
}
.breakout{
    margin-left: 20px;
}
  `, "",{"version":3,"sources":["webpack://./src/styles/compaign.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;;AAE1B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,eAAe;IACf,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,eAAe;IACf,8BAA8B;AAClC;;;;AAIA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,SAAS;IACT,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,iBAAiB;AACrB","sourcesContent":[".list-container{\n    display: flex;\n    flex-direction: column;\n    \n}\n\n.list-container .single-list{\n    margin: 10px 10px;\n    display: flex;\n    justify-content: space-between;\n}\n.list-container li{\n    display: inline-block;\n    width: 40%;\n}\n\n.list-container .cross-icon:hover{\n    cursor: pointer;\n}\n\n.rendered-heading{\n    margin: 5px 10px;\n    font-size:medium;\n    text-transform: uppercase;\n}\n\n.compaign-form{\n    border: 1px solid #343A40 ;\n    border-radius: 5px;\n    padding: 10px 10px;\n    position: relative;\n}\n\n.compaign-form .submit{\n    position: absolute;\n    bottom: 5px;\n    right: 4px;\n    padding:3px 3px;\n    border: 1px solid black;\n    border-radius: 10%;\n}\n\n.compaign-form .submit:hover{\n    cursor: pointer;\n    background-color: #c6d4e1;\n}\n\n.compaign-form .options-container{\n    display: flex;\n    justify-content: space-between;\n    width: 85%%;\n}\n\n.options-container .channel{\n    display: flex;\n    flex-direction: column;\n}\n\n.options-container .channel span{\n    color: red;\n}\n\n.options-container select,input{\n    height: 25px;\n    padding: 2px 5px;\n    outline: none;\n}\n\n.optional-options{\n    margin-top: 15px;\n    margin-bottom: 45px;\n}\n\n.optional-options-container{\n    display: flex;\n    width: 95%;\n    margin: 5px 0px;\n    justify-content: space-between;\n}\n\n\n\n.optimization, .added-value{\n    display: flex;\n    justify-content: center;\n    text-align: center;\n}\n\n.optimization label, .added-value label{\n    margin-right: -10px;\n}\n\naxiOptimization{\n    margin-left: -5px;\n}\n\n\n.download-button:hover{\n    cursor: pointer;\n    background-color: #DEE2E6;\n}\n\n.optional-options-container input[type='text']{\n    width: 250px;\n}\n\n.input-label{\n    margin-right: -5px;\n}\n\n\n.campaign-number span{\n    color: red;\n    margin-right: 5px;\n}\n\n.platform-container span{\n    color: red;\n}\n\n.adgroup-form .buttons {\n    position: absolute;\n    bottom: 5px;\n    right: -5px;\n}\n\n.buttons{\n    position: absolute;\n    margin-right: 10px;\n    display: flex;\n    width: 150px;\n    justify-content: space-around;\n    left: 86%;\n    bottom: 5px;\n}\n\n.buttons button{\n    padding: 2px 5px;\n}\n\n.pl-container{\n    display: flex;\n    flex-direction: column;\n}\n\n.pl-container span{\n    font-size: 12px;\n}\n\n.asterick{\n    display: flex;\n}\n.breakout{\n    margin-left: 20px;\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
